// A change to one ledger row shows at once, then is saved. If the save is refused, the row goes back to what it
// showed before and the caller is told, so a rejected change never stays on screen looking done
// (triage FE-07-03). Returns whether the change was saved.
export async function editRowOptimistically({ rows, id, patch, setRows, save, onFail }) {
  const row = rows.find((r) => r.id === id);
  const before = {};
  for (const key of Object.keys(patch)) before[key] = row?.[key];
  setRows((prev) => prev.map((r) => (r.id === id ? { ...r, ...patch } : r)));
  try {
    await save();
    return true;
  } catch (err) {
    setRows((prev) => prev.map((r) => (r.id === id ? { ...r, ...before } : r)));
    onFail(err);
    return false;
  }
}
